module.exports = __webpack_public_path__ + "static/media/POPUP.295b178d.svg";